export const KYB_DOCUMENT_TYPE = Object.freeze({
  FINANCIAL_STATEMENTS: 'FINANCIAL_STATEMENTS',
  ORGANIZATION_CHART: 'ORGANIZATION_CHART',
  TRADING_BANK_STATEMENTS: 'TRADING_BANK_STATEMENTS',
  UBO_SOF: 'SOURCE_OF_FUNDS',
  SOW: 'SOURCE_OF_WEALTH_PROOF'
} as const)
